import {JsonProperty} from 'json-typescript-mapper';
import {Contract} from './contract.model';

export class ContractHistory {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('validFrom')
  public validFrom?: string;

  @JsonProperty('boothWidth')
  public boothWidth?: number;

  @JsonProperty('boothDepth')
  public boothDepth?: number;

  @JsonProperty('boothWidthAdditional')
  public boothWidthAdditional?: number;

  @JsonProperty('boothDepthAdditional')
  public boothDepthAdditional?: number;

  @JsonProperty('specialPrice')
  public specialPrice?: number;

  @JsonProperty('divergentEnergy')
  public divergentEnergy?: boolean;

  @JsonProperty('energyAdvancedPayment')
  public energyAdvancedPayment?: number;

  @JsonProperty('isSpecial')
  public isSpecial?: boolean;

  @JsonProperty('boothWidthWinter')
  public boothWidthWinter?: number;

  @JsonProperty('boothDepthWinter')
  public boothDepthWinter?: number;

  @JsonProperty('boothWidthWinterAdditional')
  public boothWidthWinterAdditional?: number;

  @JsonProperty('boothDepthWinterAdditional')
  public boothDepthWinterAdditional?: number;

  @JsonProperty('energyType')
  public energyType?: string;

  @JsonProperty('energyTypeWinter')
  public energyTypeWinter?: string;

  @JsonProperty('salesunitNumber')
  public salesunitNumber?: number;

  @JsonProperty('contractNumberInternal')
  public contractNumberInternal?: string;

  @JsonProperty({clazz: Contract, name: 'contract'})
  public contract?: Contract;

  @JsonProperty('rythm')
  public rythm?: number;

  @JsonProperty('contractGguid')
  public contractGguid?: string;

  @JsonProperty('useWinterSize')
  public useWinterSize?: boolean;

  @JsonProperty('useAdditionalWinterSize')
  public useAdditionalWinterSize?: boolean;

  @JsonProperty('size')
  public size?: number;

  @JsonProperty('sizeAdditional')
  public sizeAdditional?: number;

  @JsonProperty('sizeWinter')
  public sizeWinter?: number;

  @JsonProperty('sizeWinterAdditional')
  public sizeWinterAdditional?: number;

  @JsonProperty('zone')
  public zone?: string;

  constructor() {
    this.id = void 0;
    this.validFrom = void 0;
    this.boothWidth = void 0;
    this.boothDepth = void 0;
    this.useWinterSize = void 0;
    this.boothWidthWinter = void 0;
    this.boothDepthWinter = void 0;
    this.boothWidthAdditional = void 0;
    this.boothDepthAdditional = void 0;
    this.size = void 0;
    this.sizeAdditional = void 0;
    this.sizeWinter = void 0;
    this.sizeWinterAdditional = void 0;
    this.useAdditionalWinterSize = void 0;
    this.boothWidthWinterAdditional = void 0;
    this.boothDepthWinterAdditional = void 0;
    this.contract = void 0;
    this.specialPrice = void 0;
    this.divergentEnergy = void 0;
    this.energyAdvancedPayment = void 0;
    this.isSpecial = void 0;
    this.energyType = void 0;
    this.energyTypeWinter = void 0;
    this.salesunitNumber = void 0;
    this.contractNumberInternal = void 0;
    this.rythm = void 0;
    this.contractGguid = void 0;
    this.zone = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/contract-history.model.ts